import httpClient from 'src/common/fetch/config'
import { OrganizationProfileModel, CreateBlockchainDetailsDTO } from './models'

import { BalanceModel } from '../wallets'
export const getOrganizationProfile = () => httpClient.get<OrganizationProfileModel>('/organizations/profile')
export const getOrganizationBalances = () => httpClient.get<Record<string, BalanceModel>>('/organizations/balances')
export const createBlockchainDetails = (data: CreateBlockchainDetailsDTO) =>
  httpClient.post('/organizations/blockchainDetails', data)
export const deleteBlockchainDetails = (blockchainDetailsId: string) =>
  httpClient.delete('/organizations/blockchainDetails', {
    params: { blockchainDetailsId }
  })

export const getEnabledBanks = () => httpClient.get<{ enabledBankIds: string[] }>('/organizations/enabled-banks')
